import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=500cf6ea"
import script from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleInfo.vue?vue&type=style&index=0&id=500cf6ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports